<section class="content">
  <div class="content-block form-new">
    <div class="m-4"></div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="materialTableHeader">
            <div class="left">
              <ul class="header-buttons-left ms-0">
                <li class="tbl-title">
                  @if (id.length === 0) {
                    <h2>{{'SUPERADMIN.TICKET.ADD_TITLE' | translate}}</h2>
                  }
                  @if (id.length > 0) {
                    <h2>{{'SUPERADMIN.TICKET.EDIT_TITLE' |
                    translate}}</h2>
                  }
                </li>
              </ul>
            </div>
            <div class="right">
              <ul class="tbl-export-btn">

                <!-- To Do  -->

                <!-- <li class="tbl-header-btn" *ngIf="id">
                <div class="m-l-10" matTooltip="{{'Notes' | translate}}">
                  <button aria-label="restore" mat-mini-fab color="primary">
                    <mat-icon class="col-white">note_alt</mat-icon>
                  </button>
                </div>
              </li> -->
              @if (id) {
                <li class="tbl-header-btn">
                  <div class="m-l-10" matTooltip="{{'Export Pdf' | translate}}">
                    <button aria-label="restore" mat-mini-fab color="primary"
                      (click)="generatePdf()">
                      <mat-icon class="col-white">picture_as_pdf</mat-icon>
                    </button>
                  </div>
                </li>
              }
              <li class="tbl-header-btn">
                                    <div class="m-l-10" matTooltip="{{'COMMON.TOOL_TIP.BACK' |
                                        translate}}">
                  <button aria-label="close" mat-mini-fab color="warn" (click)="confirmExit()">
                    <mat-icon class="col-white">close</mat-icon>
                  </button>
                </div>
              </li>

            </ul>
          </div>
        </div>
        <div>
          <form class="register-form m-4" [formGroup]="ticketform">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>{{'SUPERADMIN.TICKET.FORM.COMPANY_NAME' | translate}}</mat-label>
                  <input matInput readonly formControlName="company_name" required>

                </mat-form-field>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>{{'SUPERADMIN.TICKET.FORM.APPLICATION_NAME' | translate}}</mat-label>
                  <input matInput readonly formControlName="ticket_prefix" required>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>{{'SUPERADMIN.TICKET.FORM.USERNAME' | translate}}</mat-label>
                  <input matInput readonly formControlName="user_name" required>

                </mat-form-field>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">

                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>{{'SUPERADMIN.TICKET.FORM.EMAIL' | translate}}</mat-label>
                  <input matInput readonly
                    placeholder="{{'SUPERADMIN.TICKET.FORM.EMAIL' | translate}}"
                    formControlName="email" required>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-2">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{'SUPERADMIN.TICKET.FORM.PHONE' | translate}}</mat-label>
                  <input matInput formControlName="phone"
                    onkeypress="return String.fromCharCode(event.charCode).match(/[^0-9]/g) === null"
                    mask="(000) 000-0000" maxlength="14"
                    placeholder="{{'SUPERADMIN.TICKET.FORM.PHONE' | translate}}" required>
                </mat-form-field>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-2">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{'SUPERADMIN.TICKET.FORM.TICKET_UPDATE' | translate}}</mat-label>
                  <input matInput
                    placeholder="{{'SUPERADMIN.TICKET.FORM.TICKET_UPDATE' | translate}}"
                    formControlName="ticket_title" required>
                </mat-form-field>
              </div>
            </div>

            <div class="row form-old">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{'SUPERADMIN.TICKET.FORM.DESCRIPTION' | translate}}</mat-label>
                  <input matInput
                    placeholder="{{'SUPERADMIN.TICKET.FORM.DESCRIPTION' | translate}}"
                    formControlName="ticket_description" required>
                </mat-form-field>
              </div>
            </div>

            <div class="attachment-button mt-3" appDnd (fileDropped)="onFileDropped($event)"
              color="primary">
              <input type="file" #fileDropRef id="fileDropRef" multiple
                (change)="fileChange($event)" />
              <label for="fileDropRef">
              {{'COMMON.ACTIONS.ATTACHMENT' | translate}}</label>
            </div>

            <div class="row cust-margin mt-2">
              <div class="files-list">
                @for (file of files; track file; let i = $index) {
                  <div class="single-file">
                    <div class="file-icon">
                      <img [src]="thumbImage(file)" alt="">
                    </div>
                    <div class="info" alignment="center">
                      <h4 class="name">
                        {{ file?.name }}
                      </h4>
                    </div>
                    <div class="delete" (click)="deleteFile(i)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18"
                        viewBox="0 0 14 18">
                        <path fill="#B1B1B1" fill-rule="nonzero"
                          d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
                      </svg>
                    </div>
                  </div>
                }
              </div>
            </div>

            @if (id) {
              <div class="row cust-margin">
                <div class="files-list">
                  @for (file of last_files_array; track file; let i = $index) {
                    <div class="single-file">
                      <div class="file-icon" (click)="imageNetworkPreview(last_files_array, i)">
                        <img [src]="thumbNetworkImage(i)" alt="">
                      </div>
                      <div class="info" alignment="center">
                        <h4 class="name">
                          {{ getName(file.split('/').pop())  }}
                        </h4>
                      </div>
                      <div class="delete" (click)="deleteFile_old(i)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18"
                          viewBox="0 0 14 18">
                          <path fill="#B1B1B1" fill-rule="nonzero"
                            d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
                        </svg>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }

            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                <button class="btn-space" mat-raised-button color="primary"
                  [disabled]="!ticketform.valid"
                  (click)="portalSaveTicket()">{{'COMMON.ACTIONS.SAVE'|
                translate}}</button>
                <button type="button" mat-raised-button color="warn"
                (click)="confirmExit()">{{'COMMON.ACTIONS.CANCEL'| translate}}</button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</section>
<ngx-gallery [options]="galleryOptions" [images]="galleryImages" #gallery></ngx-gallery>
